import React from "react";
// import { useTranslation } from "react-i18next";

// const groupContent = {
//   A: (
//     <div className="bg-blue-50 rounded-lg p-4">
//       <h4 className="font-semibold text-blue-900 mb-2">🔹 A組</h4>
//       <p className="text-blue-700 mb-2">
//         如果醫師幫你評分後發現，你的呼吸道症狀比較輕微（例如 mMRC &lt; 2 或 CAT
//         &lt; 10），而且最近一年內沒有因為急性發作而跑急診或住院，就會歸類在 A
//         組。
//       </p>
//       <p className="text-blue-700">
//         → A 組的治療是使用一種支氣管擴張劑就可以（可以是長效或短效的）。
//       </p>
//     </div>
//   ),
//   B: (
//     <div className="bg-green-50 rounded-lg p-4">
//       <h4 className="font-semibold text-green-900 mb-2">🔹 B組</h4>
//       <p className="text-green-700 mb-2">
//         如果你的呼吸道症狀比較明顯（例如 mMRC ≥ 2 或 CAT ≥
//         10），但最近一年內仍沒有住院或嚴重發作，會歸類為 B 組。
//       </p>
//       <p className="text-green-700">
//         →
//         建議使用兩種長效吸入藥，稱為雙長效支氣管擴張劑（例如：適倍樂舒沛噴吸入劑
//         Spiolto、安肺樂易利達乾粉吸入劑 Anoro、必肺宜氣化噴霧劑 Bevespi）。
//       </p>
//     </div>
//   ),
//   E: (
//     <div className="bg-red-50 rounded-lg p-4">
//       <h4 className="font-semibold text-red-900 mb-2">🔹 E組</h4>
//       <p className="text-red-700 mb-2">
//         如果你在過去一年內曾經住院，或有兩次以上的中度急性發作（例如需要吃藥或掛急診），會歸類為
//         E 組。
//       </p>
//       <p className="text-red-700">
//         → 一開始就需要使用雙長效支氣管擴張劑（如：Spiolto、Anoro、Bevespi）。
//       </p>
//       <p className="text-red-700 mt-2">
//         → 如果有過敏體質（例如抽血看到嗜酸性球 ≥ 300
//         顆/uL），可以加吸入型類固醇（例如使肺泰、吸必擴等）一起使用三合一吸入劑（例如：肺樂喜易利達乾粉吸入劑
//         Trelegy、倍舒樂定量噴霧劑 Breztri、喘寶定量吸入劑 Trimbow）。
//       </p>
//     </div>
//   ),
// };

const DiseaseAndTreatment = () => {
  // const { t } = useTranslation();
  // const [group, setGroup] = useState("A");

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">
          疾病認識與治療
        </h1>
      </div>

      {/* 疾病介紹部分 */}
      <div className="space-y-8 mb-16">
        <div className="bg-white rounded-lg shadow-lg p-6">
          <h2 className="text-2xl font-semibold text-green-900 mb-4">
            什麼是慢性阻塞性肺病？
          </h2>

          <div className="mb-8">
            <div className="text-gray-700 mb-4">
              <p className="indent-8 mb-2">
                慢性阻塞性肺病是一種肺部的慢性疾病，由於氣道發炎（如支氣管炎、細支氣管炎）和/或肺泡異常、失去彈性(如肺氣腫)所導致，進而造成持續性、逐漸惡化的氣流受限。這個疾病造成空氣進得去卻出不來，就像一個氣球被綁太緊，吹得進去，放氣卻放得很慢、很吃力。主要的慢性呼吸道症狀像是呼吸困難、咳嗽、痰液產生、急性惡化發作等。
              </p>
              <p className="indent-8 mb-2">
                引起這些變化的常見原因包括長期抽菸，也有些人是因為吸到髒空氣，比如汽機車廢氣、廚房油煙，或是在工作場所吸入粉塵、煙霧、化學物質等。
                如果你經常咳嗽、咳痰、覺得喘、呼吸困難，或是活動一下就很累，再加上曾經長期接觸過這些空氣污染來源、長期抽菸，就要考慮是否有慢性阻塞性肺病。
              </p>
            </div>
          </div>

          <div className="mb-8">
            <h3 className="text-xl font-semibold text-green-900 mb-4">
              慢性阻塞性肺病怎麼診斷？
            </h3>
            <p className="indent-8 text-gray-700 mb-4">
              醫師會安排「肺功能檢查」來協助確認診斷。檢查時，您需要先吸飽氣，再用力、快速地把氣吹出。如果發現第一秒鐘所吹出的氣量，低於您整口氣用力吹到底所能吹出的總量的七成，就可以懷疑有氣流受限的情形。此時，醫師會再安排「支氣管擴張劑試驗」，讓您吸入支氣管擴張藥後，再重做一次肺功能檢查，以判斷氣流受限是否具有可逆性。如果吸入藥物後，第一秒鐘所吹出的氣量仍低於總量的七成，這時就可以診斷為慢性阻塞性肺病。{" "}
            </p>
          </div>

          <div className="mb-8">
            <h3 className="text-xl font-semibold text-green-900 mb-4">
              慢性阻塞性肺病怎麼治療？
            </h3>
            <div className="mb-8">
              {/* 短效支氣管擴張劑 */}
              <div className="flex items-start mb-2">
                <span className="font-bold">
                  短效支氣管擴張劑（緊急時使用）
                </span>
              </div>
              <div className="mb-4">
                醫師可能會開立一種短效的吸入藥，像是備勞喘這類的噴霧劑。這種藥可以在日常生活中如果突然感到很喘，或咳嗽變嚴重時緊急使用，幫助緩解呼吸困難的情形。
                <br />
                但如果您發現最近常常需要使用這類藥，而且還有喘鳴聲、血氧下降、痰變黃或發燒的情況，這時就要趕快回診，或直接到急診，讓醫師評估是否有急性發作。
              </div>

              {/* 長效支氣管擴張劑 */}
              <div className="flex items-start mb-2">
                <span className="font-bold">長效支氣管擴張劑怎麼用？</span>
              </div>
              <div className="mb-4">
                醫師會根據您的病情嚴重程度，開立合適的支氣管擴張劑。這些藥物可以幫助您減少喘的情況、改善日常活動的能力，並降低急性發作的機會。臺大醫院目前常用於治療慢性阻塞性肺病的支氣管擴張劑如下表所示。
              </div>

              {/* 口服類固醇副作用 */}
              <div className="flex items-center mb-2">
                <span className="font-bold">口服類固醇長期使用的副作用</span>
              </div>
              <div className="mb-2">
                當您有急性發作時，醫師可能會使用口服類固醇和抗生素治療，出院後有時也會建議繼續服用幾天。如果門診追蹤時仍有喘鳴聲或有急性發作的相關症狀，也可能短期使用這類藥物。但如果長期服用類固醇，可能會出現以下副作用：
              </div>
              <ul className="pl-12 mb-4 list-disc text-gray-700">
                <li>胃潰瘍、腸胃不適</li>
                <li>血糖上升，對糖尿病控制不利</li>
                <li>骨質疏鬆，容易骨折</li>
                <li>肌肉無力、萎縮</li>
                <li>視力變差或白內障</li>
                <li>感染風險增加，特別是肺部感染或結核病復發</li>
              </ul>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>
                  是否需要使用口服類固醇，應由醫師依照您的身體狀況來評估決定使用的時機和時間。不過，您可以留意前面提到的可能的不適，並適時向醫師反映，以便進一步調整治療。
                </li>
              </ul>
            </div>

            <div className="mb-8">
              <h3 className="text-xl font-semibold text-gray-900 mb-4">
                其他藥物治療
              </h3>
              <div className="mb-4">
                <h4 className="text-lg font-semibold text-gray-900 mb-2">
                  化痰藥（如乙醯半胱胺酸）
                </h4>
                <p className="text-gray-700">
                  可以幫助減少發作、改善生活品質。有研究顯示，每天規律服用
                  600～1200
                  毫克的劑量，可以降低急性惡化的次數，特別是對於尚未使用吸入型類固醇的病人效果更明顯。
                </p>
              </div>
              <div className="mb-4">
                <h4 className="text-lg font-semibold text-gray-900 mb-2">
                  茶鹼類藥物（如菲康汀）
                </h4>
                <p className="text-gray-700">
                  可以幫助支氣管擴張，改善呼吸，但要小心副作用如心悸、失眠，且容易和其他藥物交互作用，所以使用前需特別小心，並與醫師討論。{" "}
                </p>
              </div>
              <div className="mb-4">
                <h4 className="text-lg font-semibold text-gray-900 mb-2">
                  日舒錠（Azithromycin）
                </h4>
                <p className="text-gray-700">
                  這是一種抗生素，但某些慢性阻塞性肺病的病人，即使沒有感染，也可能因慢性發炎而使用這類藥物。每天或隔天服用，可以減少發作次數。不過需由醫師評估是否適合，因為有可能會影響腸胃或心律。{" "}
                </p>
              </div>
              <div className="mb-4">
                <h4 className="text-lg font-semibold text-gray-900 mb-2">
                  杜避炎單株抗體（Dupilumab）
                </h4>
                <p className="text-gray-700">
                  這是一種針劑型的生物製劑，針對有嚴重過敏性體質或嗜酸性球偏高的病人，若經常反覆急性惡化，可能會考慮使用。這類治療通常要經過嚴格的評估與追蹤，才能決定是否適合長期使用。{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 治療方法部分 */}
      <div className="space-y-8">
        <div className="bg-white rounded-lg shadow-lg p-6 mb-8">
          <div className="mb-8">
            <h3 className="text-xl font-semibold text-gray-900 mb-4">
              表1、台大醫院慢性阻塞性肺病病患常用維持性治療處方
            </h3>
            <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-4">
              <p className="text-yellow-700">
                吸入器類型說明：
                <ul className="list-disc pl-6">
                  <li>MDI：定量噴霧吸入器（Metered Dose Inhaler）</li>
                  <li>DPI：乾粉吸入器（Dry Powder Inhaler）</li>
                  <li>SMI：柔霧吸入器（Soft Mist Inhaler）</li>
                </ul>
              </p>
            </div>
          </div>

          <div className="mb-8">
            <div className="overflow-x-auto w-full mb-4">
              <table className="min-w-max border-collapse w-full text-center">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="px-2 py-1 border">學名</th>
                    <th className="px-2 py-1 border">劑型</th>
                    <th className="px-2 py-1 border">商品名（英文）</th>
                    <th className="px-2 py-1 border">商品名（中文）</th>
                    <th className="px-2 py-1 border">藥效時間</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colSpan={5} className="border px-2 py-1 text-center">
                      乙型交感神經緩作用劑 (b-agonist)
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={5} className="border px-2 py-1 text-center">
                      短效乙型交感神經緩作用劑 (SABA, short acting beta agonist)
                    </td>
                  </tr>
                  <tr>
                    <td className="border px-2 py-1">Fenoterol</td>
                    <td className="border px-2 py-1">定量噴霧吸入器</td>
                    <td className="border px-2 py-1">
                      Berotec N Metered Aerosol
                    </td>
                    <td className="border px-2 py-1">備勞喘定量噴霧液</td>
                    <td className="border px-2 py-1">3-5小時</td>
                  </tr>
                  <tr>
                    <td className="border px-2 py-1">Fenoterol</td>
                    <td className="border px-2 py-1">口服液</td>
                    <td className="border px-2 py-1">Strolin Liquid</td>
                    <td className="border px-2 py-1">適喘寧液</td>
                    <td className="border px-2 py-1">6-7小時</td>
                  </tr>
                  <tr>
                    <td className="border px-2 py-1">
                      Salbutamol（Albuterol）
                    </td>
                    <td className="border px-2 py-1">噴霧吸入劑</td>
                    <td className="border px-2 py-1">Ventolin Nebules</td>
                    <td className="border px-2 py-1">泛得林呼吸溶液劑</td>
                    <td className="border px-2 py-1">4-6小時</td>
                  </tr>
                  <tr>
                    <td className="border px-2 py-1">Terbutaline</td>
                    <td className="border px-2 py-1">噴霧吸入劑</td>
                    <td className="border px-2 py-1">Butanyl IH Soln</td>
                    <td className="border px-2 py-1">必坦寧吸入液</td>
                    <td className="border px-2 py-1">4-6小時</td>
                  </tr>
                  <tr>
                    <td colSpan={5} className="border px-2 py-1 text-center">
                      抗乙醯膽鹼藥物 (anticholinergic)
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={5} className="border px-2 py-1 text-center">
                      短效抗乙醯膽鹼藥物 (SAMA, short acting muscarinic
                      antagonist)
                    </td>
                  </tr>
                  <tr>
                    <td className="border px-2 py-1">Ipratropium Bromide</td>
                    <td className="border px-2 py-1">噴霧吸入劑</td>
                    <td className="border px-2 py-1">
                      Atrovent Nebulizer Solution
                    </td>
                    <td className="border px-2 py-1">定喘樂單一劑量吸入液</td>
                    <td className="border px-2 py-1">4小時</td>
                  </tr>
                  <tr>
                    <td colSpan={5} className="border px-2 py-1 text-center">
                      長效抗乙醯膽鹼藥物 (LAMA, long acting muscarinic
                      antagonist){" "}
                    </td>
                  </tr>
                  <tr>
                    <td className="border px-2 py-1">Tiotropium</td>
                    <td className="border px-2 py-1">柔霧吸入器</td>
                    <td className="border px-2 py-1">Spiriva Respimat</td>
                    <td className="border px-2 py-1">適喘樂舒沛噴吸入劑</td>
                    <td className="border px-2 py-1">24小時</td>
                  </tr>
                  <tr>
                    <td colSpan={5} className="border px-2 py-1 text-center">
                      短效乙型交感神經作用劑及短效抗乙醯膽鹼藥物複方(SABA/SAMA)
                    </td>
                  </tr>
                  <tr>
                    <td className="border px-2 py-1">
                      Salbutamol / Ipratropium
                    </td>
                    <td className="border px-2 py-1">噴霧吸入劑</td>
                    <td className="border px-2 py-1">Combivent UDV</td>
                    <td className="border px-2 py-1">冠喘衛單一劑量吸入液</td>
                    <td className="border px-2 py-1">6-8小時</td>
                  </tr>
                  <tr>
                    <td colSpan={5} className="border px-2 py-1 text-center">
                      長效乙型交感神經作用劑及長效抗乙醯膽鹼藥物複方(LABA/LAMA)
                    </td>
                  </tr>
                  <tr>
                    <td className="border px-2 py-1">
                      Umeclidinium / Vilanterol
                    </td>
                    <td className="border px-2 py-1">乾粉吸入器</td>
                    <td className="border px-2 py-1">Anoro Ellipta</td>
                    <td className="border px-2 py-1">安肺樂易利達乾粉吸入劑</td>
                    <td className="border px-2 py-1">24小時</td>
                  </tr>
                  <tr>
                    <td className="border px-2 py-1">
                      Olodaterol / Tiotropium
                    </td>
                    <td className="border px-2 py-1">柔霧吸入器</td>
                    <td className="border px-2 py-1">Spiolto Respimat</td>
                    <td className="border px-2 py-1">適倍樂舒沛噴吸入劑</td>
                    <td className="border px-2 py-1">24小時</td>
                  </tr>
                  <tr>
                    <td className="border px-2 py-1">
                      Glycopyrronium / Formoterol
                    </td>
                    <td className="border px-2 py-1">定量噴霧吸入器</td>
                    <td className="border px-2 py-1">Bevespi Aerosphere</td>
                    <td className="border px-2 py-1">必肺宜氣化噴霧劑</td>
                    <td className="border px-2 py-1">12小時</td>
                  </tr>
                  <tr>
                    <td colSpan={5} className="border px-2 py-1 text-center">
                      長效乙型交感神經作用劑及吸入性類固醇複方 (LABA/ICS)
                    </td>
                  </tr>
                  <tr>
                    <td className="border px-2 py-1">
                      Salmeterol / Fluticasone
                    </td>
                    <td className="border px-2 py-1">定量噴霧吸入器</td>
                    <td className="border px-2 py-1">Seretide 125 Evohaler</td>
                    <td className="border px-2 py-1">使肺泰125優氟吸入劑</td>
                    <td className="border px-2 py-1">12小時</td>
                  </tr>
                  <tr>
                    <td className="border px-2 py-1">
                      Salmeterol / Fluticasone
                    </td>
                    <td className="border px-2 py-1">定量噴霧吸入器</td>
                    <td className="border px-2 py-1">Seretide 250 Evohaler</td>
                    <td className="border px-2 py-1">使肺泰250優氟吸入劑</td>
                    <td className="border px-2 py-1">12小時</td>
                  </tr>
                  <tr>
                    <td className="border px-2 py-1">
                      Formoterol / Budesonide
                    </td>
                    <td className="border px-2 py-1">定量噴霧吸入器</td>
                    <td className="border px-2 py-1">Symbicort Rapihaler</td>
                    <td className="border px-2 py-1">吸必擴氣化噴霧劑</td>
                    <td className="border px-2 py-1">12小時</td>
                  </tr>
                  <tr>
                    <td className="border px-2 py-1">
                      Vilanterol / Fluticasone
                    </td>
                    <td className="border px-2 py-1">乾粉吸入器</td>
                    <td className="border px-2 py-1">Relvar Ellipta</td>
                    <td className="border px-2 py-1">潤娃易利達乾粉吸入劑</td>
                    <td className="border px-2 py-1">24小時</td>
                  </tr>
                  <tr>
                    <td colSpan={5} className="border px-2 py-1 text-center">
                      長效乙型交感神經作用劑、抗乙醯膽鹼藥物及吸入性類固醇複方
                      (LABA/LAMA/ICS){" "}
                    </td>
                  </tr>
                  <tr>
                    <td className="border px-2 py-1">
                      Vilanterol / Umeclidinium / Fluticasone
                    </td>
                    <td className="border px-2 py-1">乾粉吸入器</td>
                    <td className="border px-2 py-1">Trelegy Ellipta</td>
                    <td className="border px-2 py-1">肺樂喜易利達乾粉吸入劑</td>
                    <td className="border px-2 py-1">24小時</td>
                  </tr>
                  <tr>
                    <td className="border px-2 py-1">
                      Formoterol / Glycopyrronium / Beclometasone
                    </td>
                    <td className="border px-2 py-1">定量噴霧吸入器</td>
                    <td className="border px-2 py-1">Trimbow</td>
                    <td className="border px-2 py-1">喘寶定量吸入劑</td>
                    <td className="border px-2 py-1">12小時</td>
                  </tr>
                  <tr>
                    <td className="border px-2 py-1">
                      Budesonide / Glycopyrronium / Formoterol Fumarate
                      Dihydrate
                    </td>
                    <td className="border px-2 py-1">定量噴霧吸入器</td>
                    <td className="border px-2 py-1">Breztri</td>
                    <td className="border px-2 py-1">必肺暢氣化噴霧劑</td>
                    <td className="border px-2 py-1">12小時</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="mb-8">
            <h3 className="text-xl font-semibold text-gray-900 mb-4">
              吸入劑操作影片
            </h3>
            <p className="text-gray-700 mb-2">
              目前臺大總院氣喘衛教網站已經有的是：備勞喘（Berotec）、適喘樂舒沛噴（Spiriva）、使肺泰（Seretide）、吸必擴（Symbicort）、潤娃易利達乾粉（Relvar）。{" "}
              <a
                href="https://media.ntuh.gov.tw/km/1133"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 underline break-all"
              >
                https://media.ntuh.gov.tw/km/1133
              </a>
            </p>
            <i className="text-gray-500 mb-2">
              預計針對安肺樂易利達乾粉（Anoro）、適倍樂舒沛噴（Spiolto）、必肺宜（Bevespi）、肺樂喜易利達乾粉（Trelegy）、喘寶（Trimbow）、以及必肺暢（Breztri）等建立操作影片。{" "}
            </i>
          </div>

          <div className="mb-8">
            <h3 className="text-xl font-semibold text-gray-900 mb-4">
              資料來源
            </h3>
            <ul className="list-disc pl-6 text-gray-700">
              <li>
                <a
                  href="https://goldcopd.org"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-700 underline break-words"
                >
                  Global Initiative for Chronic Obstructive Lung Disease (GOLD).
                  (2025). Global strategy for the prevention, diagnosis and
                  management of chronic obstructive pulmonary disease: 2025
                  report.
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiseaseAndTreatment;
